import React, { HTMLAttributes } from 'react';
import ContentCard from '../ContentCard';
import { DiscoverySiteSponsor } from '../../../../../../store/features/discovery';
import Link from '../../../../../shared/Link/Link';
import { useBuildUrl } from '../../../../../../hooks/useBuildUrl';
import { useGetImgixImageUrl } from '../../../../../../hooks';
import styles from './SponsorCard.module.scss';

export interface SponsorCardProps
  extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  data: DiscoverySiteSponsor;
}

export function SponsorCard(props: SponsorCardProps) {
  const { name, categoryName, photo, path } = props.data;
  const sponsorUrl = useBuildUrl('sponsors', path);
  const image = useGetImgixImageUrl(photo);

  const renderTitle = <div className={styles.title}>{name}</div>;

  const renderImage = (
    <div
      data-testid="sponsor-photo"
      style={{
        backgroundImage: image
          ? `url(${image})`
          : '/images/default-silhouette.png',
      }}
      className={styles.image}
    />
  );

  const renderFooter = <div className={styles.footer}>{categoryName}</div>;

  return (
    <Link to={sponsorUrl} className={styles.link}>
      <ContentCard
        image={renderImage}
        title={renderTitle}
        footer={renderFooter}
        className="site-card"
      />
    </Link>
  );
}
